<template>
  <div class="t-datepicker">
    <div class="t-check-in"></div>
    <div class="t-check-out"></div>
  </div>
</template>

<script>
    //import moment from 'moment'
    import { calendar } from '../../_config'
    import { datesHelper } from '../../_helpers'

    export default {
        name: "AYRDatepicker",
        props:['dates', 'format', 'single','maximoDias'],
        data(){
            return {
                datepicker: null,
                converted:null,
                limpiar: false
            }
        },
        mounted(){
            this.limpiar = this.clear;

            if(!this.single) {

                this.datepicker = $(this.$el).tDatePicker({
                    limitDateRanges: this.maximoDias,
                    formatDate: calendar.formatDate,
                    iconArrowTop: calendar.iconArrowTop,
                    iconCalendar: calendar.iconCalendar,
                    startDate: datesHelper.initialDate(),
                    numCalendar: calendar.numCalendar,
                    statusDays:this.dates
                }).on('selectedCI', this.checkin).on('selectedCO', this.checkout);
            }else {

                this.datepicker = $(this.$el).tDatePicker({
                    limitDateRanges: this.maximoDias,
                    formatDate: calendar.formatDate,
                    iconArrowTop: calendar.iconArrowTop,
                    iconCalendar: calendar.iconCalendar,
                    startDate: datesHelper.initialDate(),
                    numCalendar: calendar.numCalendar,
                    statusDays:this.dates
                }).on('selectedCI', this.checkin).on('selectedCO', this.checkout);
            }

        },
        methods: {
            checkin(e, dataDate){
                this.$emit('checkInChanged', datesHelper.dateToMoment(dataDate))
            },
            checkout(e, dataDate){
                this.$emit('checkOutChanged', datesHelper.dateToMoment(dataDate))
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/booking/AYRDatepicker.vue